import { getPreferences, PreferenceCategory } from '@atlassian/browser-storage-controls';

/**
 * Returns true when the user has consented to Functional storage preferences.
 *
 * The FOMO nudge persists "shown / dismissed" state to localStorage to avoid
 * repeatedly showing the same nudge to the same user. Per Atlassian cookie
 * policy, this requires explicit Functional consent.
 *
 * Returns false on error or when preferences are unavailable, to fail safely
 * (no nudge is shown rather than risk a compliance violation).
 */
export async function canShowFomoNudge(): Promise<boolean> {
	try {
		const prefs = await getPreferences();

		return Boolean(prefs?.[PreferenceCategory.Functional]);
	} catch {
		return false;
	}
}
